import { render } from "./ModalTextSingle.vue?vue&type=template&id=7bb13fd3"
import script from "./ModalTextSingle.vue?vue&type=script&lang=js"
export * from "./ModalTextSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__